import { MutableRefObject, RefObject, useRef } from 'react';
import useCurrentGroup from '../../../../hooks/useCurrentGroup';

interface GridHeightDifference {
  inputRefs: MutableRefObject<{
    [x: string]: HTMLDivElement;
  }>;
  wrapperRef: RefObject<HTMLDivElement>;
  setGridForHeight: () => boolean;
}

const useInputGridHeightDifference = (): GridHeightDifference => {
  const currentGroup = useCurrentGroup();

  /**
   * These refs are used for the setGridForHeight function
   */
  const inputRefs = useRef<{ [x: string]: HTMLDivElement }>({});
  const wrapperRef = useRef<HTMLDivElement>(null);

  /**
   * This function calculates the height difference. If this difference
   * is too high, it will automatically show the grid as 1 column.
   * This improves the UI
   */
  const setGridForHeight = () => {
    if (
      Object.keys(inputRefs.current).length === 0 ||
      currentGroup.questions.length < 4
    )
      return false;
    let maxHeight = 0;
    let minHeight = Number.MAX_VALUE;
    Object.values(inputRefs.current).forEach((elem) => {
      const height = (elem as HTMLDivElement)?.offsetHeight;
      if (height > maxHeight) maxHeight = height;
      if (height < minHeight) minHeight = height;
    });

    if (maxHeight - minHeight > 120 && wrapperRef.current) return true;
    return false;
  };

  return { inputRefs, wrapperRef, setGridForHeight };
};

export default useInputGridHeightDifference;
